import React, { useState } from "react";

/**
 * Circular society avatar — renders the icon image when available, falling
 * back to the first character of the society name on error / no icon.
 */
const SocietyAvatar: React.FC<{ icon?: string; name: string; className?: string }> = ({
  icon,
  name,
  className = "h-16 w-16 text-2xl",
}) => {
  const [failed, setFailed] = useState(false);
  if (!icon || failed) {
    return (
      <span
        className={`mx-auto flex items-center justify-center rounded-full bg-[#ffa217] font-bold text-white ring-2 ring-white/60 ${className}`}
      >
        {name.charAt(0)}
      </span>
    );
  }
  return (
    <img
      src={icon}
      alt={name}
      className={`mx-auto rounded-full border object-cover ${className}`}
      onError={() => setFailed(true)}
    />
  );
};

export default SocietyAvatar;